// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aecbc9ef","560":"ce10e4fa"}[chunkId] + ".chunk.js";
};